import { handleImg } from './img';
import { handleCode } from './code';
import { handleCodeV2, handleCodeV2FromOldDoc } from './codeV2';
import { handleTitle } from './title';

export const formatHtml = (html) => {
  let result = html;
  result = handleImg(result);
  // v1接口拉老文档
  result = handleCode(result);
  // v2接口拉新文档
  result = handleCodeV2(result);
  // v2接口拉老文档
  result = handleCodeV2FromOldDoc(result);
  result = handleTitle(result);
  return result;
};
